export const ONBOARDING_ID_TOKEN_KEY = 'oitk';
export const SESSION_TOKEN_KEY = 'stk';
export const ALL_AUTH_OBJECT_KEY = 'aaok';
export const USER_PROFILE_OBJECT_KEY = 'up';
export const USER_PRIVILEGES_OBJECT_KEY = 'upv';
